<template>
  <div class="wrapper border-bottom white-bg page-heading">
    <div class="container">
      <div class="row">
        <div class="col-xs-8 col-sm-10 col-lg-10">
          <h1><i class="far fa-id-card m-r-sm"></i> Drivers</h1>
        </div>
        <div class="col-xs-4 col-sm-2 col-lg-2">
          <div class="text-right m-t-lg">
            <router-link
              v-if="loggedInUserIsCarrier"
              data-toggle="tooltip"
              data-placement="left"
              title=""
              data-original-title="Create New Driver"
              class="material-plus"
              :to="{ name: 'drivers.create' }"
            >+</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    loggedInUserIsCarrier () {
      return this.$user.isCarrier
    }
  }
}
</script>



// WEBPACK FOOTER //
// IndexHeading.vue?d6bd48fa